module.exports = __webpack_public_path__ + "static/media/افضل شقق في انترلاكن.88bd568d.jpg";